/** Where an instructor sign-in keeps its JWT; read back by loadInitialAuthenticationStateAsync. */
export const INSTRUCTOR_TOKEN_KEY = "access_token";

/** Stores an instructor JWT exactly as the password and passwordless sign-ins do. */
export const storeInstructorAccessToken = (token: string): void => {
  localStorage.setItem(INSTRUCTOR_TOKEN_KEY, token);
};

/** Removes the stored instructor JWT. */
export const removeInstructorAccessToken = (): void => {
  localStorage.removeItem(INSTRUCTOR_TOKEN_KEY);
};
